import axios from '@/axios'

const test = {
  async getData(params) {
    return await axios.get('123123123', params, { des: '直客pc获取账户资料基本信息', sTime: new Date().getTime() })
  },
  // 获取用户ip归属地
  async getIpAddress(params) {
    return await axios.post('/common/getIpAddress', params, { des: '获取用户ip归属地', sTime: new Date().getTime() })
  },
}

export default test



// WEBPACK FOOTER //
// ./src/api/test.js